export var DEFAULT_DATE_TIME_FORMAT = 'MMM d, yyyy';
//# sourceMappingURL=types.js.map